import React from 'react';
import { string } from 'prop-types';

import cx from 'classnames';
import s from './UserBadge.css';


// Displays User initials.
const UserBadge = ({ className, firstInitial = '', lastInitial = '' }) =>
  <div className={cx(s.component, className)}>
    <div className={s.initials}>
      {firstInitial}{lastInitial}
    </div>
  </div>;

UserBadge.propTypes = {
  firstName: string,
  lastName: string,
  propClassName: string,
};

export default UserBadge;



// WEBPACK FOOTER //
// ./src/components/UserBadge/UserBadge.js